import { Box1, Clock } from 'iconsax-react';
import { ReactNode } from 'react';

export const ProductStatusBar = ({ children }: { children?: ReactNode }) => {
  return <div className="flex flex-row items-center gap-4">{children}</div>;
};

export type ProductStatusProps = {
  variant?: 'open' | 'close' | 'available' | 'last' | 'empty';
  children?: ReactNode;
};

export const ProductStatus = ({
  variant = 'open',
  children,
}: ProductStatusProps) => {
  switch (variant) {
    case 'open':
      return (
        <div className="text-[#17C964] text-sm flex flex-row items-center gap-x-1.5">
          <Clock
            className="select-none border-none outline-none"
            color="#17C964"
            size="16"
            variant="Bold"
          />
          {children ?? 'Открыто'}
        </div>
      );
    case 'close':
      return (
        <div className="text-[#9CA5AC] text-sm flex flex-row items-center gap-x-1.5">
          <Clock
            className="select-none border-none outline-none"
            color="#9CA5AC"
            size="16"
            variant="Bold"
          />
          {children ?? 'Закрыто'}
        </div>
      );
    case 'available':
      return (
        <div className="text-[#2D7BEF] text-sm flex flex-row items-center gap-x-1.5">
          <Box1
            className="select-none border-none outline-none"
            color="#2D7BEF"
            size="16"
            variant="Bold"
          />
          {children ?? ' Товар в наличии'}
        </div>
      );
    case 'last':
      return (
        <div className="text-[#F5A524] text-sm flex flex-row items-center gap-x-1.5">
          <Box1
            className="select-none border-none outline-none"
            color="#F5A524"
            size="16"
            variant="Bold"
          />
          {children ?? 'Осталось 10 шт'}
        </div>
      );
    case 'empty':
      return (
        <div className="text-[#F53639] text-sm flex flex-row items-center gap-x-1.5">
          <Box1
            className="select-none border-none outline-none"
            color="#F53639"
            size="16"
            variant="Bold"
          />
          {children ?? 'Нет в наличии'}
        </div>
      );
  }
};
